export async function post<
  Data,
  T extends Record<string, unknown> = Record<string, unknown>,
>(url: string, dataObject?: T) {
  const response = await fetch(url, {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(dataObject),
  });

  if (response.ok) {
    const responseBody: Data = await response.json();
    return responseBody;
  }

  throw response;
}

export async function get<
  Data,
  T extends Record<string, unknown> = Record<string, unknown>,
>(url: string, params?: T) {
  const query = new URLSearchParams(params as Record<string, string>).toString();
  const response = await fetch(`${url}?${query}`, {
    headers: { Accept: 'application/json' },
  });

  if (response.ok) {
    const responseBody: Data = await response.json();
    return responseBody;
  }

  throw response;
}

export async function put<
  Data,
  T extends Record<string, unknown> = Record<string, unknown>,
>(url: string, dataObject?: T) {
  const response = await fetch(url, {
    method: 'put',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(dataObject),
  });

  if (response.ok) {
    const responseBody: Data = await response.json();
    return responseBody;
  }

  throw response;
}

export async function del<
  Data,
  T extends Record<string, unknown> = Record<string, unknown>,
>(url: string) {
  const response = await fetch(`${url}`, {
    method: 'delete',
    headers: { Accept: 'application/json' },
  });

  if (response.ok) {
    const responseBody: Data = await response.json();
    return responseBody;
  }

  throw response;
}
